<template>
  <div v-if="isImpersonating" class="impersonation-alert">
    <div class="alert alert-warning" role="alert">
      <i class="bi bi-eye-fill"></i> 
      <strong>Impersonating User:</strong> {{ impersonatedUserName }}
      <button @click="exitImpersonation" class="btn btn-sm btn-dark ml-2">
        <i class="bi bi-box-arrow-left"></i> Exit
      </button>
    </div>
  </div>
</template>

<script>
// import api from '@/services/api';

export default {
  name: 'ImpersonationAlert',
  data() {
    return {
      isImpersonating: false,
      originalAdminToken: null,
      originalAdminUser: null,
      impersonatedUser: null
    };
  },
  computed: {
    impersonatedUserName() {
      if (!this.impersonatedUser) return '';
      return `${this.impersonatedUser.first_name} ${this.impersonatedUser.last_name}`;
    }
  },
  methods: {
    exitImpersonation() {
      // Restore the original admin token and user info
      if (this.originalAdminToken) {
        localStorage.setItem('authToken', this.originalAdminToken);
      }
      
      if (this.originalAdminUser) {
        localStorage.setItem('user', JSON.stringify(this.originalAdminUser));
      }
      
      // Clear impersonation flags
      localStorage.removeItem('isImpersonating');
      localStorage.removeItem('impersonatedUser');
      localStorage.removeItem('originalAdminToken');
      localStorage.removeItem('originalAdminUser');
      
      // Redirect to admin dashboard
      window.location.href = '/admin/dashboard';
    }
  },
  created() {
    // Check if we're in impersonation mode
    this.isImpersonating = localStorage.getItem('isImpersonating') === 'true';
    
    if (this.isImpersonating) {
      // Get stored info
      this.originalAdminToken = localStorage.getItem('originalAdminToken');
      
      try {
        this.originalAdminUser = JSON.parse(localStorage.getItem('originalAdminUser') || '{}');
        this.impersonatedUser = JSON.parse(localStorage.getItem('user') || '{}');
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }
};
</script>

<style scoped>
.impersonation-alert {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 5px 15px;
}

.alert {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  font-size: 14px;
}

.btn {
  margin-left: 10px;
}

.bi {
  margin-right: 5px;
}
</style>